<div class="layout-container">
  <app-side-nav class="sidebar"></app-side-nav>
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
</div>
